import {regionsByPricingTiers} from "../constants/regionsByPricingTier";
import {RegionSlug} from "../store/types";
import {PricingTier} from "./fetchPricingData";

const DEFAULT_TIER = "tier2";

export const getPricingTierByRegionSlug = (slug: RegionSlug): PricingTier => {
  const result = Object.entries(regionsByPricingTiers).find(([, value]) => value.includes(slug));

  if (!result) return DEFAULT_TIER;

  const [tier] = result;

  return tier as PricingTier;
};
